<!-- New-version banner -->
<div *ngIf="versionCheck.hasNewVersion" class="app-update-banner">
  <span> يوجد تحديث جديد للتطبيق.</span>
  <button (click)="versionCheck.hardReload()">تحديث الآن</button>
</div>

<router-outlet></router-outlet>
